import {
    CancelOutlined as CancelOutlinedIcon,
    CheckCircleOutlined as CheckCircleOutlinedIcon
} from '@material-ui/icons';
import {
    Box, Button, CardContent, Dialog, DialogContent, DialogTitle, FormControl, FormGroup, FormLabel, InputLabel,
    Select, TextField, Tooltip, Typography
} from '@material-ui/core';
import api from '../../../services/api';
import React, { Component } from 'react';
import ComboPadrao from 'views/Components/ComboPadrao';
import { ATIPO_EXTERNO, ATIPO_INTERNO } from '../../../consts';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { formatCurrency, formatDateForInput, validateField } from 'lib/functions';
import { isInvalidSelect } from 'lib/configUtils';

class AbastecimentoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            abastecimento: {
                codabastecimento: '',
                codveiculo: '',
                codfuncionario: '',
                codcategoriacombustivel: '',
                codcombustivel: '',
                data: '',
                codprojeto: '',
                tipoabastecimento: '',
                descricao: '',
                volumeabastecimento: '',
                valor: '',
                precoporlitro: '',
                kmatual: '',
                nronf: ''
            },
            errors: {},
            errorsModal: {},
            veiculos: [],
            motoristas: [],
            categoriascombustivel: [],
            combustiveis: [],
            projetos: [],
            postos: [],
            bombas: [],
            isNewRecord: false,
            isView: false,
            openMotivoModal: false,
            schema: {
                data: {
                    presence: { allowEmpty: false, message: 'Data obrigatória' },
                    length: { maximum: 10 },
                    type: 'date'
                },
                codveiculo: {
                    presence: { allowEmpty: false, message: 'Veículo obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                kmatual: {
                    presence: { allowEmpty: false, message: 'Hodômetro inválido' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                volumeabastecimento: {
                    presence: { allowEmpty: false, message: 'Volume obrigatório' },
                    length: { maximum: 100 },
                    type: 'number'
                },
                valor: {
                    presence: { allowEmpty: false, message: 'Valor total obrigatório' },
                    length: { maximum: 100 },
                    type: 'number'
                },
                codfuncionario: {
                    presence: { allowEmpty: false, message: 'Motorista obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codcombustivel: {
                    presence: { allowEmpty: false, message: 'Combustível obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codcategoriacombustivel: {
                    presence: { allowEmpty: false, message: 'Categoria de combustível obrigatória' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codpostocombustivel: {
                    presence: { allowEmpty: false, message: 'Posto de combustível obrigatório' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                codbomba: {
                    presence: { allowEmpty: false, message: 'Bomba interna obrigatória' },
                    length: { maximum: 100 },
                    type: 'integer'
                },
                descricao: {
                    presence: { allowEmpty: false, message: 'Descrição motivo abastecimento obrigatória' },
                    length: { maximum: 5000 },
                    type: 'string'
                }
            }
        }
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const { abastecimento } = this.state;
        const currentPath = location.pathname;

        if (id >= 0) {
            try {
                const response = await api.get(`/abastecimento/${id}`);
                const dados = (response.data && response.data.data && response.data.data[0]) ? response.data.data[0] : {};

                // "let params" somente quando é preciso passar filtro específico de uma tabela
                let paramsveiculo = `?page=1&limit=500&veiculoproprio=S`;
                let paramsmotorista = `?page=1&limit=500&funcionario=S`;
                let paramsposto = `?page=1&limit=500&postocombustivel=S`;

                const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
                this.setState({
                    veiculos: (veiculos.data?.data || []).map(item => ({
                        ...item,
                        placanroveiculo: item.placa && item.nroveiculo ? `${item.placa} [${item.nroveiculo}]` : (item.nroveiculo || '')
                    }))
                });

                const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
                this.setState({ motoristas: motoristas.data });

                const postos = await api.get(`/fornecedor/active/true${paramsposto}`);
                this.setState({ postos: postos.data });

                const categoriascombustivel = await api.get(`/categoriacombustivel/listforchange/${dados.codcategoriacombustivel}`);
                this.setState({ categoriascombustivel: categoriascombustivel.data });

                const combustiveis = await api.get(`/combustivel/listforchange/${dados.codcombustivel}`);
                this.setState({ combustiveis: combustiveis.data });

                const projetos = await api.get(`/financas/projeto/listforchange/${dados.codprojeto}`);
                this.setState({ projetos: projetos.data });

                const bombas = await api.get(`/bomba/listforchange/${dados.codbomba}`);
                this.setState({ bombas: bombas.data });

                console.log('DADOS RECEBIDOS DO BACKEND:', JSON.stringify(dados, null, 2));

                if (dados && dados.kmatual === undefined) {
                    dados.kmatual = null;
                }

                this.setState({
                    abastecimento: {
                        ...dados,
                        data: dados.data ? formatDateForInput(dados.data) : '',
                        tipoabastecimento: String(dados.tipoabastecimento || ATIPO_EXTERNO),
                        descricao: dados.descricao || ''
                    },
                    isNewRecord: false,
                    isView: (currentPath.includes('/view'))
                });
            } catch (error) {
                console.error('Erro ao carregar:', error);
            }
        } else if (id === 'novo') {
            this.setState({
                isNewRecord: true,
                abastecimento: {
                    ...abastecimento,
                    descricao: '',
                    tipoabastecimento: ATIPO_EXTERNO,
                    kmatual: 0
                }
            });

            // "let params" somente quando é preciso passar filtro específico de uma tabela
            let paramsmotorista = `?page=1&limit=500&funcionario=S`;
            let paramsveiculo = `?page=1&limit=500&veiculoproprio=S`;
            let paramsposto = `?page=1&limit=500&postocombustivel=S`;

            const veiculos = await api.get(`/veiculo/active/true${paramsveiculo}`);
            this.setState({
                veiculos: (veiculos.data?.data || []).map(item => ({
                    ...item,
                    placanroveiculo: item.placa && item.nroveiculo ? `${item.placa} [${item.nroveiculo}]` : (item.nroveiculo || '')
                }))
            });

            const motoristas = await api.get(`/fornecedor/active/true${paramsmotorista}`);
            this.setState({ motoristas: motoristas.data });

            const categoriascombustivel = await api.get(`/categoriacombustivel/active/true`);
            this.setState({ categoriascombustivel: categoriascombustivel.data });

            const combustiveis = await api.get(`/combustivel/active/true`);
            this.setState({ combustiveis: combustiveis.data });

            const projetos = await api.get(`/financas/projeto/active/true`);
            this.setState({ projetos: projetos.data });

            const postos = await api.get(`/fornecedor/active/true${paramsposto}`);
            this.setState({ postos: postos.data });

            const bombas = await api.get(`/bomba/active/true`);
            this.setState({ bombas: bombas.data || bombas.data?.data || [] });
        }
    };

    /* Evento on change componentes */
    OnChange = async (event) => {
        const { name, value, type, checked } = event.target;

        // atualiza o abastecimento de forma controlada
        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [name]: type === 'checkbox' ? checked : value
            };

            // preenche automaticamente combustível vinculado ao veículo
            if (name === 'codveiculo') {
                const veiculoSelecionado = prevState.veiculos.find(
                    item => String(item.codveiculo) === String(value)
                );

                if (veiculoSelecionado && veiculoSelecionado.codcombustivel) {
                    novo.codcombustivel = veiculoSelecionado.codcombustivel;
                } else {
                    novo.codcombustivel = '';
                }

                if (veiculoSelecionado && veiculoSelecionado.codprojeto) {
                    novo.codprojeto = veiculoSelecionado.codprojeto;
                } else {
                    novo.codprojeto = '';
                }
            }

            // troca de tipo de abastecimento
            if (name === 'tipoabastecimento') {
                if (value === ATIPO_EXTERNO) {
                    novo.codbomba = '';
                }

                if (value === ATIPO_INTERNO) {
                    novo.codpostocombustivel = '';
                }
            }

            // calcula preço por litro
            const volume = parseFloat(novo.volumeabastecimento);
            const valorTotal = parseFloat(novo.valor);

            if (!isNaN(volume) && !isNaN(valorTotal) && volume > 0 && valorTotal > 0) {
                novo.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                novo.precoporlitro = '';
            }

            return { abastecimento: novo };
        });

        if (name === 'tipoabastecimento' && value === ATIPO_INTERNO) {
            const response = await api.get('/bomba/active/true');
            const lista = response.data?.data || response.data || [];
            this.setState({ bombas: lista });
        }
    };

    /* Abre modal motivo abastecimento */
    handleOpenMotivoModal = () => {
        this.setState({
            openMotivoModal: true,
            errorsModal: {}
        });
    };

    /* Fecha modal motivo abastecimento */
    handleCloseMotivoModal = () => {
        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });
    };

    /* Muda descrição motivo abastecimento (?) */
    handleChangeDescricaoMotivo = (event) => {
        const { value } = event.target;

        this.setState(prev => ({
            abastecimento: {
                ...prev.abastecimento,
                descricao: value
            },
            errorsModal: {
                ...prev.errorsModal,
                descricao: ''
            }
        }));
    };

    /* Atualiza dados de abastecimento existente - post */
    handleUpdateAbastecimento = async () => {
        const { abastecimento } = this.state;
        try {
            const response = await api.put(`/abastecimento/${abastecimento.codabastecimento}`, abastecimento);
            if (response.status === 200) {
                this.props.history.push('/frotas/abastecimento');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { abastecimento, isNewRecord } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        // validação extra para ComboPadrao obrigatório
        const comboFields = [
            {
                field: 'codveiculo',
                message: 'Selecione um veículo válido'
            },
            {
                field: 'codfuncionario',
                message: 'Selecione um motorista válido'
            },
            {
                field: 'codcategoriacombustivel',
                message: 'Selecione uma categoria de combustível válida'
            },
            {
                field: 'codcombustivel',
                message: 'Selecione um combustível válido'
            }
        ];

        if (abastecimento.tipoabastecimento == ATIPO_EXTERNO) {
            comboFields.push({
                field: 'codpostocombustivel',
                message: 'Selecione um posto de combustível válido'
            });
        }

        if (abastecimento.tipoabastecimento == ATIPO_INTERNO) {
            comboFields.push({
                field: 'codbomba',
                message: 'Selecione uma bomba interna válida'
            });
        }

        const comboErrors = {};

        comboFields.forEach(({ field, message }) => {
            if (isInvalidSelect(abastecimento[field])) {
                comboErrors[field] = message;
            }
        });

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        if (isNewRecord) {
            this.handleOpenMotivoModal();
            return;
        }

        await this.handleSubmitAbastecimento();
    };

    /* Confirma motivo abastecimento */
    handleConfirmMotivoModal = async () => {
        const { abastecimento, schema } = this.state;
        const descricaoError = validateField('descricao', abastecimento.descricao, schema);

        if (descricaoError) {
            this.setState({
                errorsModal: {
                    descricao: descricaoError
                }
            });
            return;
        }

        this.setState({
            openMotivoModal: false,
            errorsModal: {}
        });

        await this.handleSubmitAbastecimento();
    };

    /* Click salvar */
    handleSubmitAbastecimento = async () => {
        const { abastecimento, isNewRecord } = this.state;

        try {
            const formData = new FormData();

            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');

            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando há campos do tipo BLOB
            formData.append('data', abastecimento.data || '');
            formData.append('valor', abastecimento.valor || '');
            formData.append('kmatual', abastecimento.kmatual || '');
            formData.append('codusuarioregistrou', Number(codusuarioregistrou));
            if (isNewRecord) {
                formData.append('descricao', abastecimento.descricao || '');
            }
            formData.append('codveiculo', abastecimento.codveiculo || '');
            formData.append('volumeabastecimento', abastecimento.volumeabastecimento || '');
            formData.append('codfuncionario', abastecimento.codfuncionario || '');
            formData.append('codcombustivel', abastecimento.codcombustivel || '');
            formData.append('codbomba', abastecimento.codbomba || '');
            formData.append('codcategoriacombustivel', abastecimento.codcategoriacombustivel || '');
            formData.append('tipoabastecimento', abastecimento.tipoabastecimento || '');
            formData.append('hora', abastecimento.hora || '');
            formData.append('codpostocombustivel', abastecimento.codpostocombustivel || '');
            formData.append('nronf', abastecimento.nronf || '');
            formData.append('precoporlitro', abastecimento.precoporlitro || '');
            formData.append('kmspercorridoabastecimento', abastecimento.kmspercorridoabastecimento || '');
            formData.append('consumoabastecimento', abastecimento.consumoabastecimento || '');
            formData.append('origem', abastecimento.origem || '');
            formData.append('codprojeto', abastecimento.codprojeto || '');
            formData.append('listacp', abastecimento.listacp || '');

            if (isNewRecord) {
                await api.post('/abastecimento', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.put(`/abastecimento/${abastecimento.codabastecimento}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            this.props.history.push('/frotas/abastecimento');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/abastecimento');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { abastecimento, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'data',
            'codveiculo',
            'kmatual',
            'volumeabastecimento',
            'valor',
            'codfuncionario',
            'codcombustivel',
            'codcategoriacombustivel'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, abastecimento[field], schema);
            if (error) {
                errors[field] = error;
            }
        });

        // hodômetro não pode ser 0 (zero)
        if (abastecimento.kmatual === 0 || abastecimento.kmatual === '0') {
            errors.kmatual = 'Hodômetro inválido';
        }

        // valida apenas o campo relacionado ao tipo de abastecimento
        if (abastecimento.tipoabastecimento == ATIPO_INTERNO) {
            const codbombaError = validateField('codbomba', abastecimento.codbomba, schema);
            if (codbombaError) {
                errors.codbomba = "Bomba interna obrigatória";
            }
        }

        if (abastecimento.tipoabastecimento == ATIPO_EXTERNO) {
            const codpostocombustivelError = validateField('codpostocombustivel', abastecimento.codpostocombustivel, schema);
            if (codpostocombustivelError) {
                errors.codpostocombustivel = "Posto de combustível obrigatório";
            }
        }

        return errors;
    };

    /* Insere novo abastecimento */
    handleInsertAbastecimento = async () => {
        const { abastecimento } = this.state;
        abastecimento.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/abastecimento`, abastecimento);
            if (response.status === 200) {
                this.props.history.push('/frotas/abastecimento');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Método para tratar campos com vírgula */
    handleChangeValorMonetario = (e, campo) => {
        const raw = e.target.value;
        const semFormatacao = raw.replace(/[^\d,]/g, '');
        const numero = parseFloat(semFormatacao.replace(',', '.'));

        this.setState(prevState => {
            const novo = {
                ...prevState.abastecimento,
                [campo]: !isNaN(numero) ? numero : ''
            };

            const volume = parseFloat(novo.volumeabastecimento);
            const valorTotal = parseFloat(novo.valor);

            if (!isNaN(volume) && !isNaN(valorTotal) && volume > 0 && valorTotal > 0) {
                novo.precoporlitro = (valorTotal / volume).toFixed(2);
            } else {
                novo.precoporlitro = '';
            }

            return { abastecimento: novo };
        });
    };

    /* Método para aceitar somente dígitos */
    handleNumericChange = (e) => {
        const { name, value } = e.target;
        const onlyDigits = value.replace(/\D/g, '');
        this.setState(prev => ({
            abastecimento: { ...prev.abastecimento, [name]: onlyDigits }
        }));
    };

    render() {
        const {
            abastecimento,
            veiculos,
            projetos,
            motoristas,
            combustiveis,
            categoriascombustivel,
            postos,
            errors,
            bombas,
            isView,
            openAlert,
            messageAlert,
            openMotivoModal,
            errorsModal
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                        style={{
                            marginBottom: '10px'
                        }}
                    >
                        Abastecimento {abastecimento.codabastecimento}
                    </Typography>

                    <br />

                    <Box width="100%">
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                marginRight: "1rem",
                                width: '25%'
                            }}
                        >
                            <ComboPadrao
                                name={'codveiculo'}
                                label={'Veículo'}
                                value={abastecimento.codveiculo}
                                onChange={this.OnChange}
                                fieldId={'codveiculo'}
                                listItems={veiculos}
                                fieldDescription={'placanroveiculo'}
                                helperText={errors.codveiculo || ''}
                                error={!!errors.codveiculo}
                            />
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                width: '50%'
                            }}
                        >
                            <ComboPadrao
                                name={'codfuncionario'}
                                label={'Motorista'}
                                value={abastecimento.codfuncionario}
                                onChange={this.OnChange}
                                fieldId={'codfornecedor'}
                                listItems={motoristas}
                                fieldDescription={'descfornecedor'}
                                helperText={errors.codfuncionario || ''}
                                error={!!errors.codfuncionario}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box width="100%">
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                marginRight: "1rem",
                                width: '35%'
                            }}
                        >
                            <ComboPadrao
                                name={'codcategoriacombustivel'}
                                label={'Categoria de Combustível'}
                                value={abastecimento.codcategoriacombustivel}
                                onChange={this.OnChange}
                                fieldId={'codcategoriacombustivel'}
                                listItems={categoriascombustivel}
                                fieldDescription={'desccategoriacombustivel'}
                                helperText={errors.codcategoriacombustivel || ''}
                                error={!!errors.codcategoriacombustivel}
                            />
                        </FormControl>

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                width: '35%'
                            }}
                        >
                            <ComboPadrao
                                name={'codcombustivel'}
                                label={'Combustível'}
                                value={abastecimento.codcombustivel}
                                onChange={this.OnChange}
                                fieldId={'codcombustivel'}
                                listItems={combustiveis}
                                fieldDescription={'desccombustivel'}
                                helperText={errors.codcombustivel || ''}
                                error={!!errors.codcombustivel}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box width="100%">
                        <TextField
                            label="Data"
                            name="data"
                            onChange={this.OnChange}
                            type="date"
                            value={abastecimento.data || ''}
                            variant="outlined"
                            disabled={isView}
                            helperText={errors.data || ''}
                            error={!!errors.data}
                            InputLabelProps={{
                                shrink: true,
                                required: false
                            }}
                            style={{
                                marginRight: '1rem',
                                width: '20%'
                            }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                width: '50%'
                            }}
                        >
                            <ComboPadrao
                                name={'codprojeto'}
                                label={'Projeto'}
                                value={abastecimento.codprojeto}
                                onChange={this.OnChange}
                                fieldId={'codprojeto'}
                                listItems={projetos}
                                fieldDescription={'descprojeto'}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box width="100%">
                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                width: '25%',
                                marginRight: '1rem'
                            }}
                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Tipo Abastecimento
                            </InputLabel>

                            <Select
                                label="Tipo Abastecimento"
                                native
                                onChange={this.OnChange}
                                value={abastecimento.tipoabastecimento}
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'tipoabastecimento'
                                }}
                            >
                                <option
                                    key={ATIPO_EXTERNO}
                                    value={ATIPO_EXTERNO}
                                >
                                    {"Externo"}
                                </option>

                                <option
                                    key={ATIPO_INTERNO}
                                    value={ATIPO_INTERNO}
                                >
                                    {"Interno"}
                                </option>
                            </Select>
                        </FormControl>

                        {abastecimento.tipoabastecimento == ATIPO_EXTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    width: '50%',
                                    transition: 'all 0.3s ease-in-out'
                                }}
                            >
                                <ComboPadrao
                                    name={'codpostocombustivel'}
                                    label={'Posto de Combustível'}
                                    value={abastecimento.codpostocombustivel}
                                    onChange={this.OnChange}
                                    fieldId={'codfornecedor'}
                                    listItems={postos}
                                    fieldDescription={'descfornecedor'}
                                    helperText={errors.codpostocombustivel || ''}
                                    error={!!errors.codpostocombustivel}
                                />
                            </FormControl>
                        )}

                        {abastecimento.tipoabastecimento == ATIPO_INTERNO && (
                            <FormControl
                                variant="outlined"
                                disabled={isView}
                                style={{
                                    width: '50%',
                                    transition: 'all 0.3s ease-in-out'
                                }}
                            >
                                <ComboPadrao
                                    name={'codbomba'}
                                    label={'Bomba Interna'}
                                    value={abastecimento.codbomba}
                                    onChange={this.OnChange}
                                    fieldId={'codbomba'}
                                    listItems={bombas}
                                    fieldDescription={'descbomba'}
                                    helperText={errors.codbomba || ''}
                                    error={!!errors.codbomba}
                                />
                            </FormControl>
                        )}
                    </Box>

                    <br />

                    <FormGroup row>
                        <TextField
                            label="Volume"
                            name="volumeabastecimento"
                            value={abastecimento.volumeabastecimento !== '' && abastecimento.volumeabastecimento !== null && abastecimento.volumeabastecimento !== undefined ? formatCurrency(abastecimento.volumeabastecimento) : '0,00'}
                            variant="outlined"
                            onChange={(e) => this.handleChangeValorMonetario(e, 'volumeabastecimento')}
                            disabled={isView}
                            type="text"
                            helperText={errors.volumeabastecimento || ''}
                            error={!!errors.volumeabastecimento}
                            style={{
                                marginRight: "1rem",
                                width: '20%'
                            }}
                        />

                        <TextField
                            label="Valor Litro"
                            name="precoporlitro"
                            value={abastecimento.precoporlitro !== '' && abastecimento.precoporlitro !== null && abastecimento.precoporlitro !== undefined ? formatCurrency(abastecimento.precoporlitro) : '0,00'}
                            variant="outlined"
                            onChange={(e) => this.handleChangeValorMonetario(e, 'precoporlitro')}
                            disabled={isView}
                            type="text"
                            style={{
                                marginRight: "1rem",
                                width: '20%'
                            }}
                        />

                        <TextField
                            label="Valor Total"
                            name="valor"
                            value={abastecimento.valor !== '' && abastecimento.valor !== null && abastecimento.valor !== undefined ? formatCurrency(abastecimento.valor) : '0,00'}
                            variant="outlined"
                            onChange={(e) => this.handleChangeValorMonetario(e, 'valor')}
                            disabled={isView}
                            type="text"
                            helperText={errors.valor || ''}
                            error={!!errors.valor}
                            style={{
                                width: '20%'
                            }}
                        />
                    </FormGroup>

                    <br />

                    <Box width="100%">
                        <TextField
                            label="Hodômetro (km rodados)"
                            name="kmatual"
                            value={abastecimento.kmatual !== '' && abastecimento.kmatual !== null && abastecimento.kmatual !== undefined ? abastecimento.kmatual : ''}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                            helperText={errors.kmatual || ''}
                            error={!!errors.kmatual}
                            style={{
                                marginRight: "1rem",
                                width: '30%'
                            }}
                        />

                        <TextField
                            label="Número Nota Fiscal"
                            name="nronf"
                            value={abastecimento.nronf || ''}
                            variant="outlined"
                            onChange={this.handleNumericChange}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                width: '30%',
                                display: (abastecimento.tipoabastecimento == ATIPO_EXTERNO) ? '' : 'none',
                                transition: 'opacity 0.3s ease-in-out'
                            }}
                        />
                    </Box>

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        variant="contained"
                        onClick={this.onClickCancel}
                        color="secondary"
                        style={{
                            marginTop: '10px',
                            marginLeft: '10px'
                        }}
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />

                <Dialog
                    open={openMotivoModal}
                    onClose={this.handleCloseMotivoModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>Motivo Abastecimento</DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <FormGroup style={{ marginBottom: 12 }}>
                            <FormLabel
                                component="legend"
                                style={{
                                    fontSize: 14,
                                    marginBottom: 8,
                                    color: errorsModal.descricao ? '#f44336' : '#616161'
                                }}
                            >
                                Descrição motivo
                            </FormLabel>

                            <textarea
                                id="descricao"
                                name="descricao"
                                value={abastecimento.descricao || ''}
                                onChange={this.handleChangeDescricaoMotivo}
                                style={{
                                    height: 140,
                                    width: '100%',
                                    padding: 12,
                                    border: errorsModal.descricao ? '1px solid #f44336' : '1px solid #cccccc',
                                    borderRadius: 6,
                                    fontFamily: 'Calibri, sans-serif',
                                    resize: 'none',
                                    outline: 'none'
                                }}
                            />

                            {errorsModal.descricao && (
                                <Typography
                                    variant="caption"
                                    style={{
                                        color: '#f44336',
                                        marginTop: 4,
                                        marginLeft: 2
                                    }}
                                >
                                    {errorsModal.descricao}
                                </Typography>
                            )}
                        </FormGroup>

                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                            style={{ gap: 16 }}
                        >
                            <Tooltip
                                title="OK"
                                enterDelay={50}
                            >
                                <CheckCircleOutlinedIcon
                                    onMouseEnter={(e) => e.currentTarget.style.color = '#32860e'}
                                    onMouseLeave={(e) => e.currentTarget.style.color = '#43b811'}
                                    onClick={this.handleConfirmMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#43b811'
                                    }}
                                />
                            </Tooltip>

                            <Tooltip
                                title="Fechar"
                                enterDelay={50}
                            >
                                <CancelOutlinedIcon
                                    onMouseEnter={(e) => e.currentTarget.style.color = '#c20000'}
                                    onMouseLeave={(e) => e.currentTarget.style.color = 'red'}
                                    onClick={this.handleCloseMotivoModal}
                                    style={{
                                        cursor: 'pointer',
                                        color: 'red'
                                    }}
                                />
                            </Tooltip>
                        </Box>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default AbastecimentoForm;